import type { SubscriptionInfo } from "model/Company";
import {
  isFreeSubscription,
  isSubscriptionLoadedForCompany,
} from "web-apps/company/utils/subscription.logic";
import type { BulkAction } from "./personView.actions";

interface TimeReportAccessInput {
  readonly companyId?: number;
  readonly isLoading: boolean;
  readonly subscription: SubscriptionInfo | null;
}

interface TimeReportAccess {
  readonly isReadOnly: boolean;
  readonly restrictedActions: readonly BulkAction[];
}

const FREE_RESTRICTED_ACTIONS: readonly BulkAction[] = [
  "retract",
  "absence",
  "reset",
];
const UNRESTRICTED_ACTIONS: readonly BulkAction[] = [];

export function resolveTimeReportAccess({
  companyId,
  isLoading,
  subscription,
}: TimeReportAccessInput): TimeReportAccess {
  return {
    isReadOnly: !isSubscriptionLoadedForCompany({
      companyId,
      isLoading,
      subscription,
    }),
    restrictedActions: isFreeSubscription(subscription)
      ? FREE_RESTRICTED_ACTIONS
      : UNRESTRICTED_ACTIONS,
  };
}
